import * as React from "react";
import {useContext} from "react";
import LoginComponent from "../LoginComponent";
import {OktaEnvContext} from "../../OktaEnvContext";
import {HelpText} from "../HelpText";

export const LoginPage = () => {

    const oktaConfig = useContext(OktaEnvContext);

    return (
        <div className="container py-8">
            <h1>Please login to access this media center</h1>
            <div className="row mt-4">
                <div className="col-md-6">
                    <div className="mb-4">
                        <LoginComponent/>
                    </div>
                    <p><a className="btn btn-ghost" href={oktaConfig.registrationLink} target="_blank" rel="noreferrer">
                        Register a new account
                    </a></p>
                </div>
                <div className="col-md-6">
                    <small>
                        <HelpText/>
                    </small>
                </div>
            </div>
        </div>
    );
};
